(() => {
  const SELECTOR = "[data-custom-store-availability]";

  const STATUS_CONFIG = [
    { key: "Til á lager", className: "is-in" },
    { key: "Lítið magn", className: "is-low" },
    { key: "Uppselt", className: "is-out" },
  ];

  function getContainer() {
    return document.querySelector(SELECTOR);
  }

  function getProductSection(container) {
    return container?.closest("[data-section-type='product__section']") || document;
  }

  function getVariantIdFromUrl() {
    return new URL(window.location.href).searchParams.get("variant");
  }

  function getVariantSkuMap(container) {
    const script = container.querySelector("[data-variant-sku-map]");
    if (!script) return {};

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error("Could not parse variant SKU map", error);
      return {};
    }
  }

  function getCurrentVariantIdFromInput(container) {
    const section = getProductSection(container);

    const input =
      section.querySelector("form.product__form-buttons .formVariantId[name='id']") ||
      section.querySelector("form.product_form .formVariantId[name='id']") ||
      section.querySelector(".formVariantId[name='id']");

    return input?.value || null;
  }

  function escapeHtml(value) {
    return String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function getCard(container) {
    return container.querySelector("[data-store-availability-card]");
  }

  function renderLoading(container) {
    const card = getCard(container);
    if (!card) return;

    card.innerHTML = `<p>Sæki birgðastöðu...</p>`;
  }

  function renderError(container) {
    const card = getCard(container);
    if (!card) return;

    card.innerHTML = `
      <div class="impact-store-availability-row">
        <span class="impact-store-availability-dot is-out"></span>
        <strong class="impact-store-availability-title">Birgðastaða ekki tiltæk</strong>
      </div>
    `;
  }

  function renderAvailability(container, availability) {
    const card = getCard(container);
    if (!card) return;

    const rows = STATUS_CONFIG.map((status) => {
      const stores = availability?.[status.key] || [];

      if (!stores.length) return "";

      return `
        <div class="impact-store-availability-row-item">
          <div class="impact-store-availability-row-head">
            <span class="impact-store-availability-dot ${status.className}"></span>
            <strong class="impact-store-availability-title">${escapeHtml(status.key)}</strong>
          </div>

          <p class="impact-store-availability-locations">
            ${stores.map(escapeHtml).join(", ")}
          </p>
        </div>
      `;
    }).join("");

    if (!rows) {
      card.innerHTML = `
        <div class="impact-store-availability-row">
          <span class="impact-store-availability-dot is-out"></span>
          <strong class="impact-store-availability-title">Uppselt</strong>
        </div>
      `;
      return;
    }

    card.innerHTML = `
      <div class="impact-store-availability-stack">
        ${rows}
      </div>
    `;
  }

  async function fetchAvailability(container, sku) {
    if (!container || !sku) {
      renderError(container);
      return;
    }

    const apiUrl = container.dataset.inventoryApiUrl;

    if (!apiUrl) {
      renderError(container);
      return;
    }

    renderLoading(container);

    const url = new URL(apiUrl);
    url.searchParams.set("variant_sku", sku);

    try {
      const response = await fetch(url.toString(), {
        method: "GET",
        mode: "cors",
        credentials: "omit",
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Inventory API returned ${response.status}`);
      }

      const availability = await response.json();
      renderAvailability(container, availability);
    } catch (error) {
      console.error("Could not fetch store availability", error);
      renderError(container);
    }
  }

  function fetchByVariantId(container, variantId) {
    if (!container || !variantId) {
      renderError(container);
      return;
    }

    const variantSkuMap = getVariantSkuMap(container);
    const sku = variantSkuMap[String(variantId)];

    if (!sku) {
      console.error("No SKU found for variant ID:", variantId, variantSkuMap);
      renderError(container);
      return;
    }

    fetchAvailability(container, sku);
  }

  function handleCurrentVariant() {
    const container = getContainer();
    if (!container) return;

    const variantIdFromInput = getCurrentVariantIdFromInput(container);

    if (variantIdFromInput) {
      fetchByVariantId(container, variantIdFromInput);
      return;
    }

    const variantIdFromUrl = getVariantIdFromUrl();

    if (variantIdFromUrl) {
      fetchByVariantId(container, variantIdFromUrl);
      return;
    }

    const initialSku = container.dataset.initialVariantSku;

    if (initialSku) {
      fetchAvailability(container, initialSku);
      return;
    }

    renderError(container);
  }

  function init() {
    const container = getContainer();
    if (!container) return;

    handleCurrentVariant();

    document.addEventListener("variant:change", (event) => {
      const variant = event?.detail?.variant;

      if (variant?.sku) {
        fetchAvailability(container, variant.sku);
        return;
      }

      if (variant?.id) {
        fetchByVariantId(container, variant.id);
      }
    });

    document.addEventListener("change", (event) => {
      const target = event.target;
      if (!target) return;

      const isVariantControl =
        target.matches("select") ||
        target.matches("input[type='radio']") ||
        target.matches(".js-variant-selector");

      if (!isVariantControl) return;

      setTimeout(() => {
        handleCurrentVariant();
      }, 150);
    });

    let lastVariantId =
      getVariantIdFromUrl() ||
      getCurrentVariantIdFromInput(container);

    setInterval(() => {
      const currentVariantId =
        getVariantIdFromUrl() ||
        getCurrentVariantIdFromInput(container);

      if (currentVariantId && currentVariantId !== lastVariantId) {
        lastVariantId = currentVariantId;
        fetchByVariantId(container, currentVariantId);
      }
    }, 350);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();